/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum JobFileType {
    Exists = 'EXISTS',
    Expired = 'EXPIRED',
    NotExists = 'NOT_EXISTS'
}

export function JobFileTypeFromJSON(json: any): JobFileType {
    return JobFileTypeFromJSONTyped(json, false);
}

export function JobFileTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobFileType {
    return json as JobFileType;
}

export function JobFileTypeToJSON(value?: JobFileType | null): any {
    return value as any;
}

